
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { notificationGroupService } from '../../services/notification-group-service';
import React, { useState } from 'react';
import NotificationSubList from './notification-sub-list';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';


const NotificationList = () => {
    const [mainStore] = useState(() => createCustomStore({
        key: "id",
        load: notificationGroupService.getListAsync,
        insert: notificationGroupService.createAsync,
        update: (key, values) => {
            return notificationGroupService.updateAsync(`${key}`, values);
        },
        remove: (key) => {
            return notificationGroupService.deleteAsync(`${key}`);
        },
    }));

    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    return (

        <React.Fragment>
            <DataGridWrapper
                props={{
                    id: 'notification-group-list', remoteOperations: true,

                    keyExpr: "id"
                }}
                permissonCode='Admin.Notification.NotificationGroup'
                datasource={mainStore}
                pagerVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={false}
                columnChooser={false}
                onRowUpdating={handleRowUpdating}
                masterDetail={NotificationSubList}
                columns={[
                    {
                        dataField: "id",
                        visible: false
                    },
                    {
                        dataField: 'groupCode',
                        caption: t('group_code'),
                        filtering: false,
                        allowSearch: false,
                    },
                    {
                        dataField: 'description',
                        caption: t('description'),
                        filtering: false,
                        allowSearch: false,
                    },
                    {
                        dataField: 'isActive',
                        caption: t('active'),
                        filtering: false,
                        allowSearch: false,
                        dataType: 'boolean',
                        calculateCellValue: (rowData: any) => {
                            return rowData.isActive || false;
                        },
                    },
                ]}
            />
        </React.Fragment>
    )
}
export default NotificationList